/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CommitSavedCommoditiesUploadRequest
 */
export interface CommitSavedCommoditiesUploadRequest {
  /**
   *
   * @type {string}
   * @memberof CommitSavedCommoditiesUploadRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CommitSavedCommoditiesUploadRequest
   */
  base64Data: string;
  /**
   *
   * @type {string}
   * @memberof CommitSavedCommoditiesUploadRequest
   */
  fileName: string;
}

/**
 * Check if a given object implements the CommitSavedCommoditiesUploadRequest interface.
 */
export function instanceOfCommitSavedCommoditiesUploadRequest(
  value: object,
): value is CommitSavedCommoditiesUploadRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  return true;
}

export function CommitSavedCommoditiesUploadRequestFromJSON(
  json: any,
): CommitSavedCommoditiesUploadRequest {
  return CommitSavedCommoditiesUploadRequestFromJSONTyped(json, false);
}

export function CommitSavedCommoditiesUploadRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CommitSavedCommoditiesUploadRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    base64Data: json["base64Data"],
    fileName: json["fileName"],
  };
}

export function CommitSavedCommoditiesUploadRequestToJSON(
  json: any,
): CommitSavedCommoditiesUploadRequest {
  return CommitSavedCommoditiesUploadRequestToJSONTyped(json, false);
}

export function CommitSavedCommoditiesUploadRequestToJSONTyped(
  value?: CommitSavedCommoditiesUploadRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    base64Data: value["base64Data"],
    fileName: value["fileName"],
  };
}
